import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import ModalDialog, {
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '@atlaskit/modal-dialog';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { useIntl } from 'src/hooks/intl';
import {
  confirmHiddenFileDialog,
  HIDDEN_FILE_DIALOG,
} from 'src/redux/pull-request/actions';

import messages from './i18n';

type Props = {
  anchor: string;
};

export const HiddenFileDialog = ({ anchor }: Props) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const onCancel = () => dispatch({ type: HIDDEN_FILE_DIALOG.CANCEL });
  const onConfirm = () => dispatch(confirmHiddenFileDialog(anchor));

  const Header = () => (
    <ModalHeader>
      <ModalTitle>
        <WarningIcon
          primaryColor={token('color.icon.warning', colors.Y300)}
          label=""
        />
        <FormattedMessage {...messages.title}>
          {txt => (
            <span style={{ marginLeft: token('space.050', '4px') }}>{txt}</span>
          )}
        </FormattedMessage>
      </ModalTitle>
    </ModalHeader>
  );

  return (
    <ModalDialog width="small" onClose={onCancel}>
      <Header />
      <ModalBody>
        <FormattedMessage tagName="p" {...messages.body} />
      </ModalBody>
      <ModalFooter>
        <CustomThemeButton onClick={onConfirm} appearance="primary">
          {intl.formatMessage(messages.confirm)}
        </CustomThemeButton>
        <CustomThemeButton onClick={onCancel} appearance="subtle">
          {intl.formatMessage(messages.cancel)}
        </CustomThemeButton>
      </ModalFooter>
    </ModalDialog>
  );
};
